import React from "react";
import { Star } from "lucide-react";
import { testimonials, studioInfo } from "../../mock";
import SectionLabel from "./SectionLabel";
import Reveal from "./Reveal";

const Testimonials = () => {
  return (
    <section id="recensioni" className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <SectionLabel>Cosa dicono di noi</SectionLabel>

      <div className="flex flex-wrap items-end justify-between gap-6 mt-8">
        <h2 className="font-display text-4xl md:text-7xl text-white">
          Parole dei nostri{" "}
          <span style={{ fontStyle: "italic", fontWeight: 800 }} className="text-white/45">
            clienti.
          </span>
        </h2>
        <div className="flex items-center gap-3">
          <span className="font-display text-4xl text-white">{studioInfo.rating}</span>
          <div>
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={`rating-star-${i}`} size={14} className="fill-white text-white" />
              ))}
            </div>
            <div className="font-mono-label text-[10px] text-white/45 mt-1">
              {studioInfo.reviews} recensioni su Google
            </div>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {testimonials.map((t, i) => (
          <Reveal key={t.name} delay={i * 100}>
            <div className="border border-white/10 rounded-sm p-8 h-full flex flex-col hover:border-white/25 transition-colors duration-500">
              <div className="flex gap-0.5 mb-6">
                {[...Array(5)].map((_, j) => (
                  <Star key={`${t.name}-star-${j}`} size={14} className="fill-white text-white" />
                ))}
              </div>
              <p className="text-white/75 leading-relaxed flex-1">“{t.text}”</p>
              <div className="flex items-center gap-4 mt-8 pt-6 border-t border-white/10">
                <div className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center font-display text-sm text-white">
                  {t.initials}
                </div>
                <div>
                  <div className="text-white font-medium">{t.name}</div>
                  <div className="font-mono-label text-[10px] text-white/40 mt-0.5">{t.when}</div>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
